import { FC, SVGProps } from 'react';

export enum ToastType {
  INFO = 'INFO',
  ERROR = 'ERROR',
  WARNING = 'WARNING',
  SUCCESS = 'SUCCESS',
}

interface BaseWebviewToastProps {
  uuid: string;
  message: string;
  duration?: number;
  type: ToastType;
}

export interface WebviewToastProps extends BaseWebviewToastProps {
  title?: string;
  iconUrl?: string;
}

export interface WebClientToastProps extends BaseWebviewToastProps {
  title?: string;
  Icon?: FC<SVGProps<SVGSVGElement>>;
  buttonText?: string;
  onClickButton?: () => void;
  ignoreLineClamp?: boolean;
  top?: string;
  mobileTop?: string;
}

export type ToastProps = WebviewToastProps | WebClientToastProps;
